// src/pages/Project.jsx
import Layout from "../layouts/Layout";

import Breadcrumb from "../components/Breadcrumb";
import ProjectSection from "../components/Project/ProjectSection";
import TestimonialSection from "../components/About/TestimonialSection";

const Project = () => (
  <Layout>
    <Breadcrumb
      title="Dự án"
      parent={{ name: "Trang chủ", path: "/" }}
    />
    <ProjectSection />
    <TestimonialSection />
  </Layout>
);

export default Project;
